import { GET } from '../request'

export const getFormacion = id => GET('/api/agora/formacion/formacion', { id })
export const getFormaciones = () =>
  GET('/api/agora/formacion/formacion/list', {})
export const getFormacionesYear = year =>
  GET('/api/agora/formacion/formacion/list/year', { year })
